import createReducer from '../utils/createReducer';
import actions from '../actions/webFormPage';
import {validateEmail, checkCreateWebformContinueBtnStatus, validatePropertiesCount} from '../utils/validate';
import {isLeadFormUserContactExists, isLeadFormUserAddressExists, getDialingCountryCode} from '../utils/commonUtil';
import {getDefaultCountryCode} from '../components/utils/createAccountUtil'

const initialState = {};

const actionHandlers = {


    [actions.SET_FIELD](state, {payload}) {
        switch (payload.fieldName) {
            case 'emailAddress': return {
                ...state,
                emailAddress: payload.fieldValue
            };

            case 'firstName': return {
                ...state,
                firstName: payload.fieldValue
            };

            case 'lastName': return {
                ...state,
                lastName: payload.fieldValue
            };

            case 'phoneNumber': return {
                ...state,
                phoneNumber: payload.fieldValue
            };

            case 'numberOfProperty': return {
                ...state,
                numberOfProperty: payload.fieldValue
            };

            case 'companyName': return {
                ...state,
                companyName: payload.fieldValue
            };

            case 'dialingCountryCode': return {
                ...state,
                dialingCountryCode: payload.fieldValue
            };

            case 'countryDialingNumber': return {
                ...state,
                countryDialingNumber: payload.fieldValue
            };

            case 'softwareName': return {
                ...state,
                softwareName: payload.fieldValue
            };

            default: return {
                ...state
            };
        }
    },

    [actions.VALIDATE_PROPERTY_COUNT_FIELD](state, {payload}) {
        const isValidPropertylCount = validatePropertiesCount(payload.fieldVal);
        if (!isValidPropertylCount) {
            return {
                ...state,
                propertyCountError: 'ipmob.input.field.required',
                enableCreateWebformContinueButton: false
            };
        }
        return {
            ...state
        };
    },

    [actions.HANDLE_ONBLUR](state, {payload}) {
        switch (payload.id) {
            case 'emailAddress':
                if (payload.value) {
                    return {
                        ...state,
                        emailError: 'ipmob.input.field.required'
                    };
                }
                return {
                    ...state,
                    emailError: (payload.value) ? '' : 'ipmob.input.field.required'
                };

            case 'firstName': return {
                ...state,
                firstNameError: (payload.value) ? '' : 'ipmob.input.field.required'
            };

            case 'lastName': return {
                ...state,
                lastNameError: (payload.value) ? '' : 'ipmob.input.field.required'
            };

            case 'phoneNumber': return {
                ...state,
                phoneNumberError: (payload.value) ? '' : 'ipmob.input.field.required'
            };

            case 'companyName': return {
                ...state,
                companyNameError: (payload.value) ? '' : 'ipmob.input.field.required'
            };

            default: return {
                ...state
            };
        }
    },

    [actions.SET_FIELD_ERROR](state, {payload}) {
        if (payload.field === 'emailAddress') {
            return {
                ...state,
                emailError: payload.msg
            };
        }
        else if (payload.field === 'firstName') {
            return {
                ...state,
                firstNameError: payload.msg
            };
        } else if (payload.field === 'lastName') {
            return {
                ...state,
                lastNameError: payload.msg
            };
        } else if (payload.field === 'phoneNumber') {
            return {
                ...state,
                phoneNumberError: payload.msg
            };
        } else if (payload.field === 'companyName') {
            return {
                ...state,
                companyNameError: payload.msg
            };
        } else if (payload.field === 'numberOfProperty') {
            return {
                ...state,
                propertyCountError: payload.msg
            };
        }
        return {
            ...state
        };
    },

    [actions.VALIDATE_EMAIL](state, {payload}) {
        const isValidEmailAddress = validateEmail(payload.fieldVal);
        if (!isValidEmailAddress) {
            return {
                ...state,
                emailError: 'ipmob.create_account.button.text_5',
                enableCreateWebformContinueButton: false
            };
        }
        return {
            ...state
        };
    },

    [actions.CREATE_WEBFORM_ACCOUNT_SERVICE_ERROR](state, {payload}) {
        return {
            ...state,
            serviceError: payload.errorKey
        };
    },

    [actions.TOGGLE_WEBFORM_CONTINUE_BUTTON](state, {}) {
        const enableCreateWebformContinueButton = checkCreateWebformContinueBtnStatus(state);
        return {
            ...state,
            enableCreateWebformContinueButton
        };
    },

    [actions.GET_WEBFORM_METADATA_SUCCESS](state, {payload}) {
        const leadFormUserInfo = payload.webformDetails;
        const dialingPhoneCode = isLeadFormUserContactExists(leadFormUserInfo) ? leadFormUserInfo.contact.phone.countryCode : '';
        const countryCode = isLeadFormUserAddressExists(leadFormUserInfo) ? leadFormUserInfo.contact.addresses[0].country : '';
        const dialingCountryCode = getDialingCountryCode(dialingPhoneCode, countryCode) || getDefaultCountryCode(payload.defaultLocale);

        return {
            ...state,
            firstName: leadFormUserInfo.firstName || '',
            lastName: leadFormUserInfo.lastName || '',
            emailAddress: leadFormUserInfo.emailAddress || '',
            dialingCountryCode,
            countryDialingNumber: dialingPhoneCode,
            phoneNumber: isLeadFormUserContactExists(leadFormUserInfo) ? leadFormUserInfo.contact.phone.number : '',
            companyName: leadFormUserInfo.companyName || ''
        };
    }
};

export default createReducer(actionHandlers, initialState);
